<div class="attribute-form-container">
    <form class="attibute-form" [formGroup]="attributeForm">
        
        <div class="form-group">
            <div class="form-item">
                <label for="name" class="required_field_label">Attribute Name</label>
                <input id="name" formControlName="name" type="text" placeholder="Enter name" required />
                <div class="form_validation_error_new" [ngClass]="{'visible': attributeForm.get('name')?.invalid && attributeForm.get('name')?.touched}">
                    <small *ngIf="attributeForm.get('name')?.errors?.['required']">Name is required</small>
                </div>
            </div>
    
            <div class="form-item">
                <label for="symbol" class="required_field_label">Symbol</label>
                <input id="symbol" formControlName="symbol" type="text" placeholder="Enter Symbol" required uppercaseInput />
                <div class="form_validation_error_new" [ngClass]="{'visible': attributeForm.get('symbol')?.invalid && attributeForm.get('symbol')?.touched}">
                    <small *ngIf="attributeForm.get('symbol')?.errors?.['required']">Symbol is required</small>
                </div>
            </div>
        </div>

        <div class="form-group">
            <div class="form-item" style="grid-column: span 2;">
                <label for="description">Description</label>
                <textarea id="description" formControlName="description" placeholder="Enter Description"></textarea>
            </div>
        </div>

        <div class="form-group">
            <div class="form-item">
                <label for="dataType" class="required_field_label">Attribute Type</label>
                <app-multi-select
                [options]="attributeTypeOptions"
                [returnRawValue]="false"
                [displayKey]="'value'"
                [valueKey]="'key'"
                [isMultiSelect]="false"
                [placeholder]="'Select Attribute Type'"
                [formControlName]="'dataType'"
                >
                </app-multi-select>
                <div class="form_validation_error_new" [ngClass]="{'visible': attributeForm.get('dataType')?.invalid && attributeForm.get('dataType')?.touched}">
                    <small *ngIf="attributeForm.get('dataType')?.errors?.['required']">Atrribute Type is required</small>
                </div>
            </div>
    
            <div class="form-item">
                <label for="values">Default Value</label>
                <ng-container [ngSwitch]="attributeForm.get('dataType')?.value">
                    <app-multi-select
                    id="values"
                    *ngSwitchCase="'BOOLEAN'"
                    [options]="booleanOptions"
                    [returnRawValue]="false"
                    [displayKey]="'value'"
                    [valueKey]="'key'"
                    [isMultiSelect]="false"
                    [placeholder]="'Select Default Value'"
                    [formControlName]="'defaultValue'"
                    >
                    </app-multi-select>

                    <input
                    *ngSwitchCase="'BIGDECIMAL'"
                    id="values"
                    formControlName="defaultValue"
                    type="number"
                    placeholder="Enter Default Value"
                    />

                    <input
                    *ngSwitchDefault
                    id="values"
                    formControlName="defaultValue"
                    type="text"
                    placeholder="Enter Default Value"
                    />
                </ng-container>
            </div>
        </div>

        <div class="form-group">
            <div class="form-item">
                <app-toggle [id]="'mandatory'" formControlName="mandatory" [label]="'Mandatory'" [toggleId]="'mandatory'" [isActive]="attributeForm.get('mandatory')?.value"></app-toggle>
            </div>
        </div>
        
    </form>
</div>